<template>
  <div class="page">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{ form.main.pur_code }}</em>
          </div>
        </div>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pur_vendname">
            <label class="weui-form-preview__label">{{customLabel.pur_vendname || "供应商"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_vendname
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_currency">
            <label class="weui-form-preview__label">{{customLabel.pur_currency || "币种"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_currency
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_code">
            <label class="weui-form-preview__label">{{customLabel.pr_code || "产品编号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_code
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pr_detail">
            <label class="weui-form-preview__label">{{customLabel.pr_detail || "产品名称"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pr_detail
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_amount">
            <label class="weui-form-preview__label">{{customLabel.pur_amount || "返利金额"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pur_amount, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_type">
            <label class="weui-form-preview__label">{{customLabel.pur_type || "返利类别"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_type
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_yamount">
            <label class="weui-form-preview__label">{{customLabel.pur_yamount || "已抵扣金额"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pur_yamount, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_namount">
            <label class="weui-form-preview__label">{{customLabel.pur_namount || "返利余额"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pur_namount, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_remark">
            <label class="weui-form-preview__label">{{customLabel.pur_remark || "备注"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_remark
            }}</span>
          </div>
          <custom-field :readOnly="true" :label="customLabel.pur_text1 || '自定义字段1'"
          v-model="form.main.pur_text1" slot="pur_text1" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pur_text2 || '自定义字段2'"
          v-model="form.main.pur_text2" slot="pur_text2" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pur_text3 || '自定义字段3'"
          v-model="form.main.pur_text3" slot="pur_text3" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pur_text4 || '自定义字段4'"
          v-model="form.main.pur_text4" slot="pur_text4" hidden="true" />
          <custom-field :readOnly="true" :label="customLabel.pur_text5 || '自定义字段5'"
          v-model="form.main.pur_text5" slot="pur_text5" hidden="true" />
        </custom-layout>
        <custom-layout
          class="weui-form-preview__bd"
          :view-config="customViewConfig"
        >
          <div class="weui-form-preview__item" slot="pur_pucode">
            <label class="weui-form-preview__label">{{customLabel.pur_pucode || "采购单号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_pucode
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_pudetno">
            <label class="weui-form-preview__label">{{customLabel.pur_pudetno || "采购行号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_pudetno
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_pudqty">
            <label class="weui-form-preview__label">{{customLabel.pd_pudqty || "采购数量"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pd_pudqty
            }} {{ form.main.pr_unit }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_pudprice">
            <label class="weui-form-preview__label">{{customLabel.pd_pudprice || "采购单价"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pd_pudprice, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_pudtotal">
            <label class="weui-form-preview__label">{{customLabel.pd_pudtotal || "采购金额"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pd_pudtotal, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_pudrebaterate">
            <label class="weui-form-preview__label">{{customLabel.pd_pudrebaterate || "采购返利率%"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pd_pudrebaterate
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pd_pudrebateamount">
            <label class="weui-form-preview__label">{{customLabel.pd_pudrebateamount || "采购返利总额"}}</label>
            <span class="weui-form-preview__value">{{
              numberFormat(form.main.pd_pudrebateamount, '#,##0.00')
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_piclass">
            <label class="weui-form-preview__label">{{customLabel.pur_piclass || "出入库类型"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_piclass == 'PURCIN' ? '采购入库' : '采购出库'
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_piinoutno">
            <label class="weui-form-preview__label">{{customLabel.pur_piinoutno || "出入库单"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_piinoutno
            }}</span>
          </div>
          <div class="weui-form-preview__item" slot="pur_pidetno">
            <label class="weui-form-preview__label">{{customLabel.pur_pidetno || "出入库行号"}}</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_pidetno
            }}</span>
          </div>
        </custom-layout>
      </div>

      <collapse class="form-preview weui-form-preview" :title="'明细（'+form.items.length+'条）'">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{item.pd_bizdetno}}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
            <div class="weui-form-preview__item" slot="pd_biztype">
              <label class="weui-form-preview__label">{{customLabel.pd_biztype || "抵扣方式"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_biztype == 'Purchase' ? '采购订单' : '其他应收'
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_bizcode">
              <label class="weui-form-preview__label">{{customLabel.pd_bizcode || "抵扣单号"}}</label>
              <span class="weui-form-preview__value">{{
                item.pd_bizcode
              }}</span>
            </div>
            <div class="weui-form-preview__item" slot="pd_amount">
              <label class="weui-form-preview__label">{{customLabel.pd_amount || "抵扣金额"}}</label>
              <span class="weui-form-preview__value">{{ numberFormat(item.pd_amount,'#,##0.00') }}</span>
            </div>
            <div class="weui-form-preview__item" slot="createTime">
              <label class="weui-form-preview__label">{{customLabel.createTime || "抵扣时间"}}</label>
              <span class="weui-form-preview__value"
                >{{ item.createTime }}</span
              >
            </div>
          </custom-layout>
        </div>
      </collapse>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入人</label>
            <span class="weui-form-preview__value">{{
              form.main.creatorName
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">录入日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.createTime
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核人</label>
            <span class="weui-form-preview__value">{{
              form.main.pur_auditman
            }}</span>
          </div>
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">审核日期</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{
              form.main.pur_auditdate
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import form from "@/mixins/form.js";
import Collapse from "@/components/Collapse.vue";
import CustomField from "@/components/field/CustomField.vue";

export default {
  mixins: [form],
  components: {
    CustomLayout,
    Collapse,
    CustomField
  },
  data() {
    return {
      baseUrl: "/api/purchase/rebate",
      caller: "PurcRebate",
      xtype: "purchase-rebate-formpanel",
    };
  }
};
</script>